import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { CardTitleStyle } from '../../styles/display/card.styles';
import React, { ReactNode, ComponentType } from 'react';

interface CardTitleProps {
    children?: ReactNode;
    component?: ComponentType<any>;
    [key: string]: any;
}

const CardTitle: React.FC<CardTitleProps> & { Style?: any } = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(CardTitleStyle, rest, children, Component);

CardTitle.Style = CardTitleStyle;

export { CardTitle };
